export default __webpack_public_path__ + "7342d69eb651b8981d1892463fce4184.svg";